import React from "react";

function Faq() {
  return (
    <>
      <section className="faq position-relative pb-5">
        <div className="text-center bb">
          <h2 className="hadding p-4 mb-0 br bl d-inline-block text-black" data-aos="fade-up">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="container">
          <div className="row ">
            <div className="col-md-10 m-auto">
              <div id="accordion">
                <div className="card" data-aos="fade-up">
                  <div className="card-header">
                    <a
                      className=""
                      data-bs-toggle="collapse"
                      href="#collapseOne"
                    >
                      WTF is Scotty the AI?
                    </a>
                  </div>
                  <div
                    id="collapseOne"
                    className="collapse show"
                    data-bs-parent="#accordion"
                  >
                    <div className="card-body">
                      Scotty ain't just another memecoin—it’s your AI-powered,
                      degen-certified crypto sidekick. Born from the depths of
                      blockchain wizardry and machine learning magic, Scotty
                      helps you trade smarter, avoid rug pulls, and stay ahead
                      of the FOMO. Think of it as your intergalactic AI
                      guardian, scanning the market at lightspeed while dropping
                      some 🔥 memes along the way.
                    </div>
                  </div>
                </div>

                <div className="card" data-aos="fade-up">
                  <div className="card-header">
                    <a
                      className="collapsed "
                      data-bs-toggle="collapse"
                      href="#collapseTwo"
                    >
                      Why is Scotty V2 a giga-brain upgrade over V1?
                    </a>
                  </div>
                  <div
                    id="collapseTwo"
                    className="collapse"
                    data-bs-parent="#accordion"
                  >
                    <div className="card-body">
                      Simple—V1 was fire, but V2 is straight-up god mode. Here’s
                      why:
                      <br />
                      🚀 Now on Solana – Faster, cheaper, and 100%
                      degen-approved
                      <br />
                      🧠 Smarter AI – Learns from the community, spits pure
                      alpha
                      <br />
                      💰 Low fees, fast swaps – No more crying over gas fees
                      <br />
                      🎁 More rewards, NFTs, and governance – Scotty’s giving
                      back!
                      <br />
                      Oh, and did we mention V1 raised over $10M in a few days?
                      Yeah, V2 is ready to go even harder.
                    </div>
                  </div>
                </div>

                <div className="card" data-aos="fade-up">
                  <div className="card-header">
                    <a
                      className="collapsed "
                      data-bs-toggle="collapse"
                      href="#collapseThree"
                    >
                      Why did Scotty migrate to Solana?
                    </a>
                  </div>
                  <div
                    id="collapseThree"
                    className="collapse"
                    data-bs-parent="#accordion"
                  >
                    <div className="card-body">
                      Because waiting for slow transactions is so Web2. Solana
                      lets Scotty:
                      <br />
                      ⚡ Send transactions faster than your ex ghosting you
                      <br />
                      💸 Charge less in fees than your morning coffee
                      <br />
                      🔗 Scale without breaking a sweat
                      <br />
                      This is meme-chain supremacy at its finest.
                    </div>
                  </div>
                </div>

                <div className="card" data-aos="fade-up">
                  <div className="card-header">
                    <a
                      className="collapsed "
                      data-bs-toggle="collapse"
                      href="#collapseThree1"
                    >
                      Where do I find the sacred scrolls of Scotty V2 wisdom?
                    </a>
                  </div>
                  <div
                    id="collapseThree1"
                    className="collapse"
                    data-bs-parent="#accordion"
                  >
                    <div className="card-body">
                      Don’t get left in the past—stay plugged into the Scotty
                      Matrix visiting our website and whitepaper.
                    </div>
                  </div>
                </div>

                <div className="card" data-aos="fade-up">
                  <div className="card-header">
                    <a
                      className="collapsed "
                      data-bs-toggle="collapse"
                      href="#collapseThree2"
                    >
                      How do I get my hands on $SCOTTY?
                    </a>
                  </div>
                  <div
                    id="collapseThree2"
                    className="collapse"
                    data-bs-parent="#accordion"
                  >
                    <div className="card-body">
                      Easy, fren. Either:
                      <br />
                      1. Join the presale (don’t fumble it like last time)
                      <br />
                      2. Buy on Solana DEXs & CEXs post-launch
                      <br />
                      3. Sacrifice a meme to the crypto gods and hope for an
                      airdrop (jk… or are we?)
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-7"></div>
          </div>
        </div>
        <div className="bb mt_1"></div>
      </section>
    </>
  );
}

export default Faq;
